import { Component, OnInit, Inject } from '@angular/core';
import { MachineService } from '../services/machine.service';
import { MAT_DIALOG_DATA, MatDialogRef, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { Machine } from '../system-data/system-data.component';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-machine-insert',
  templateUrl: './machine-insert.component.html',
  styleUrls: ['./machine-insert.component.css'],
  providers:[
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class MachineInsertComponent implements OnInit {
  id: number;
  name: string;
  last_check: string;
  constructor(private machineService: MachineService, public dialogRef: MatDialogRef<MachineInsertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Machine) {
    this.name = machineService.getname();
    this.id = machineService.getid();
    this.last_check = machineService.getlast_check();
  }

  ngOnInit() {
  }

  closeModal() {
      this.dialogRef.close();
  }

}
